import { echartsDarkTheme } from "../constants/echartsDarkTheme.js";
import React, { useEffect } from "react";
import { Constants, useAtalayaContext } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import * as echarts from "echarts/core";
import { GridComponent } from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
//#region src/modules/Stats/shared/DayOfWeekBarChart.tsx
echarts.use([
	GridComponent,
	BarChart,
	CanvasRenderer
]);
echarts.registerTheme("THERMS Dark", echartsDarkTheme);
function DayOfWeekBarChart({ dowCount }) {
	const { isDarkMode } = useAtalayaContext();
	const containerRef = React.useRef(null);
	useEffect(() => {
		if (!containerRef.current || !dowCount) return void 0;
		const chart = echarts.init(containerRef.current, isDarkMode ? "THERMS Dark" : "light");
		const dowList = [
			1,
			2,
			3,
			4,
			5,
			6,
			0
		].map((dow) => dowCount[dow] ?? 0);
		let highDOWIndex;
		let lowDOWIndex;
		Object.entries(dowList).forEach(([index, count]) => {
			if (count === Math.max(...dowList)) highDOWIndex = Number(index);
			else if (count === Math.min(...dowList)) lowDOWIndex = Number(index);
		});
		const option = {
			series: [{
				data: dowList.map((count, i) => ({
					itemStyle: { color: i === highDOWIndex ? Constants.Color[isDarkMode ? "Dark" : "Light"].InfoLight : i === lowDOWIndex ? Constants.Color[isDarkMode ? "Dark" : "Light"].InfoDark : Constants.Color[isDarkMode ? "Dark" : "Light"].Info },
					value: count
				})),
				type: "bar"
			}],
			title: {
				left: "center",
				text: "Activity Per Day of the Week"
			},
			xAxis: {
				data: [
					"Mon",
					"Tue",
					"Wed",
					"Thu",
					"Fri",
					"Sat",
					"Sun"
				],
				type: "category"
			},
			yAxis: { type: "value" }
		};
		chart.setOption(option);
		return () => chart.dispose();
	}, [
		dowCount,
		containerRef.current,
		isDarkMode
	]);
	return /* @__PURE__ */ jsx("div", {
		className: "h-full w-full",
		ref: containerRef,
		style: {
			height: 300,
			width: "100%"
		}
	});
}
//#endregion
export { DayOfWeekBarChart };

//# sourceMappingURL=DayOfWeekBarChart.js.map